import { render, staticRenderFns } from "./pos-documents.vue?vue&type=template&id=3cd48d49"
import script from "./pos-documents.vue?vue&type=script&lang=js"
export * from "./pos-documents.vue?vue&type=script&lang=js"
import style0 from "./pos-documents.vue?vue&type=style&index=0&id=3cd48d49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports